export const getProductById = (products, productId) => {
    
    console.log('!!',products, productId);
    return products?.find(p => p.id === productId)
} //

export const getTotal = (_products, cartItems) => {
  return (cartItems || []).reduce((sum, item) => {
    const basePrice = Number(item.product?.price) || 0;
    const optionPrice = Number(item.productOption?.extraPrice) || 0;
    const unitPrice = optionPrice > 0 ? optionPrice : basePrice;

    return sum + unitPrice * (Number(item.amount) || 0);
  }, 0);
};

